module.exports = __webpack_public_path__ + "static/media/Green-P.d7398f6e.png";